import { Color, Spacing } from '@persona-id/design-tokens';
import { VFC } from 'react';
import styled from 'styled-components';

import PersonaIcon from 'dashboard/components/PersonaIcon';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Paragraph } from 'design-system/components/Text';
import { headingMixins } from 'design-system/mixins/text';
import { BASE } from 'design-system/variables/spacing';

const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const LeftLogo = styled.div`
  width: ${BASE * 4.5}px;
  height: ${BASE * 4.5}px;
  margin-right: ${Spacing[3]};
  padding: 6px;
  border-radius: ${({ theme }) => theme.element.borderRadius};
  background: ${Color.CorePurple100};
`;

const Card = styled.div`
  display: flex;
  width: 100%;
  border: 2px solid ${Color.CoreSlate50};
  border-radius: ${Spacing[2]};
  padding: 14px;
  background-color: ${Color.PrimaryWhite};
  align-items: center;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const SubTitle = styled.div`
  ${headingMixins.sm}
  padding-bottom: ${Spacing[2]};
`;

const TriggerConfigDirect: VFC<{ handleClose: () => void }> = ({ handleClose }) => {
  return (
    <>
      <Container>
        <HorizontalContainer>
          <SubTitle>Trigger Step</SubTitle>
        </HorizontalContainer>
        <Spacer height={2} />
        <Card>
          <LeftLogo>
            <PersonaIcon active={false} />
          </LeftLogo>
          <TextContainer>
            <h4>Direct Trigger</h4>
            <Paragraph>User actions on a Dynamic Flow Inquiry</Paragraph>
          </TextContainer>
        </Card>
        <Spacer />
      </Container>
      <Spacer />
      <HStack equal={true}>
        <Button id='trigger-direct__control-panel-close' onClick={handleClose}>
          Close
        </Button>
      </HStack>
    </>
  );
};

export default TriggerConfigDirect;
